export default __webpack_public_path__ + "static/media/Wat_1.256.932f4a8d.png";